export default __webpack_public_path__ + "static/media/error-cross-icon.29f98b07.svg";